import { Component, Prop, h } from '@stencil/core';

import Logo from '../../../assets/logos/ICO_Dealer.svg';
import { textResetSizeType } from '../../../utils/utils.interactive-banner';
@Component({
  tag: 'banner-logo',
  styleUrl: './banner-logo.css',
})
export class BannerLogo {
  @Prop() textLink: string;
  @Prop() hiddenOnMobile = false;
  @Prop() txtLinkHiddenOnDesktop = false;
  @Prop() showDesktop: boolean = false;
  @Prop() hiddenReset: boolean = false;
  @Prop() textResetSize: textResetSizeType = 'xs';
  @Prop() logoWithMPTop: boolean = true;

  render() {
    const hasLink = this.textLink !== '';

    const logoClass = {
      'mt-8': this.showDesktop && !hasLink,
      'mt-3': this.showDesktop && hasLink && this.logoWithMPTop,
      'w-40': !this.showDesktop,
      'w-44': this.showDesktop,
    };

    const resetClass = {
      'flex justify-end': this.showDesktop && !this.hiddenReset,
      hidden: (this.hiddenOnMobile && !this.showDesktop) || (this.showDesktop && this.txtLinkHiddenOnDesktop) || this.hiddenReset,
    };

    const BannerLogoClass = {
      'flex justify-between h-auto': true,
      'pt-4': !this.showDesktop && this.logoWithMPTop,
      'flex-col-reverse ml-auto': this.showDesktop,
    };

    return (
      <div class={BannerLogoClass}>
        <img src={Logo} title="KBB ICO Logo" class={logoClass} />
        <banner-reset textLink={this.textLink} class={resetClass} showDesktop={this.showDesktop} textResetSize={this.textResetSize} />
      </div>
    );
  }
}
